import assets from "../../assets";
import "./style.sass";

export const CommonPopup = ({
  open,
  title = "Success",
  description = "",
  buttonText = "OK",
  onClose,
  onConfirm,
  children,
  url,
}) => {
  if (!open) return null;

  return (
    <section className="popup_overlay">
              <section className="popup_box">
        {url&&<section className="url_img_wrapper">
          <img src={assets.ic_close} alt="close" onClick={onClose}/>
        </section>}
        {!url&&<section>
         <h3>{title}</h3>
        <p>{description}</p>

        <section className="popup_actions">
          <button
            className="popup_btn"
            onClick={() => {
              onConfirm?.(); // optional
              onClose?.();
            }}
          >
            {buttonText}
          </button>
        </section>
        </section>}
        <section>{children}</section>
      </section>
    </section>
  );
};
